<template>
	<v-row>
		<v-col>
			<v-row v-for="day in days" :key="day">
				<v-col>
					<day :day="day" :opnhr="opnhrs[day]" />
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Day from './components/Day'

export default {
	name: 'OpnHrs',

	components: { Day },

	computed: {
		...mapGetters({
			opnhrs: 'auth/opnhrs'
		})
	},

	data() {
		return {
			days: [1, 2, 3, 4, 5, 6, 0]
		}
	}
}
</script>

<style lang="scss" scoped></style>
